/* eslint-disable import/no-cycle */
/* eslint-disable no-plusplus */

import { BaseOptionType } from "antd/es/select";
import { getToLocalStorage } from "../../Library/Utils";
import { convertText } from "../Languages";

export const graphDownloadAsOptions = [
  {
    value: "pdf",
    label: "Pdf"},
  { value: "excel", label: "Excel" },
];

export const activityDayoptions = [
  { label: "Mon", value: "Monday" },
  { label: "Tue", value: "Tuesday" },
  { label: "Wed", value: "Wednesday" },
  { label: "Thu", value: "Thursday" },
  { label: "Fri", value: "Friday" },
  { label: "Sat", value: "Saturday" },
  { label: "Sun", value: "Sunday" },
];

export const allowedDocumentExtenstions =
  ".doc, .docx, .ppt, .pptx, .xls, .xlsx, .gdoc, .gsheet, .gslides, .pdf, .txt, .zip, .rar, .csv, .tsv, .jpg, .jpeg, .png";

export const ALLOWED_COMMENT_EXTENSIONS = [
  "doc",
  "docx",
  "ppt",
  "pptx",
  "xls",
  "xlsx",
  "pdf",
  "txt",
  "zip",
  "rar",
  "csv",
  "jpg",
  "jpeg",
  "png",
];
export const MAX_COMMENT_FILE_SIZE = 10 * 1024 * 1024; // 10 MB
export const MAX_COMMENT_FILES = 3;

export const allowedProfilePictureExtensions = [".jpg", ".gif", ".png"];

export const convertActivityDateFormat = "YYYY-MM-DD[T]HH:mm:ss.123[Z]";

export const convertMeetingDateFormat = "YYYY-MM-DDTHH:mm:ss.SSSZ";

export const objectiveDefaultSortColumn = "order";

export const defaultCurrentPage = 1;
export const defaultPageSize = 10;
export const defaultPageSizeOptions = [10, 20, 30, 50, 100];
export const customerSegmentPageSizeOptions = [5, 10, 20, 30, 50, 100];
export const userPageSizeOptions = [20, 30, 50, 100];

export const overviewDefaultPageSize = 20;
export const overviewDefaultPageSizeOptions = [20, 30, 50, 100];

export const activityOverviewPageSizeOptions = [20, 30, 50, 100];
export const processOverviewPageSizeOptions = [20, 30, 50, 100];

export const userDefaultPageSize = 20;

export const activityOverviewDefaultPageSize = 20;

export const initiativePersonDefaultPageSize = 8;

export const addUResponsiblePersonListDefaultPageSize = 10;
export const default100PageSize = 10;
export const addUserPersonListDefaultPageSize = 7;
export const roleListDefaultPageSize = 7;
export const divisionListDefaultPageSize = 7;

export const activityRecordsDefaultType = "open";

export const settingsTabKeysForOnlyCeo = [
  "general",
  "planning",
  "reviews",
  "forecast",
  // Settings → Tags is admin-only; the API rejects non-admin writes too.
  "tags",
];

const currentYear = new Date().getFullYear();

export const kpiYearOptions = Array.from({ length: 14 }, (_, i) => ({
  value: currentYear - i,
  label: `${currentYear - i}`}));

export const objectiveYearOptions = Array.from({ length: 10 }, (_, i) => ({
  value: `${currentYear - i}`,
  label: `${currentYear - i}`}));

export const reviewYearOptions = Array.from({ length: 10 }, (_, i) => ({
  value: `${currentYear - i}`,
  label: `${currentYear - i}`}));

export const monthNameByNumbers: any = {
  1: convertText("january"),
  2: convertText("february"),
  3: convertText("march"),
  4: convertText("april"),
  5: convertText("may"),
  6: convertText("june"),
  7: convertText("july"),
  8: convertText("august"),
  9: convertText("september"),
  10: convertText("october"),
  11: convertText("november"),
  12: convertText("december")};

export const priorities = ["low", "medium", "high"];

export const languageOptions = [
  { value: "En", label: "English" },
  { value: "De", label: "Deutsch / German (Standard)" },
];

export const dateFormatOptions = [
  {
    value: "YYYY/MM/DD",
    label: "YYYY/MM/DD - 2023/01/28"},
  {
    value: "MM/DD/YYYY",
    label: "MM/DD/YYYY - 01/28/2023"},
  {
    value: "DD.MM.YYYY",
    label: "DD.MM.YYYY - 28.01.2023"},
];

export const numberFormatOptions = [
  {
    value: "en-US",
    label: "100,000 - English"},
  { value: "de-DE", label: "100.000 - Deutsch / German" },
];

export const defaultDateFormat = "DD.MM.YYYY";
export const defaultNumberFormat = "de-DE";
export const defaultLanguage = getToLocalStorage("language") || "De";

export const numericValueRegex = /^[0-9]+$/;

/**
 * Enum representing individual planning modules.
 *
 * @enum {string}
 * @property {string} KpiPlanning - Represents the KPI planning module.
 * @property {string} InitiativePlanning - Represents the initiative planning module.
 * @property {string} RecurringActivityPlanning - Represents the recurring activity planning module.
 * @property {string} DocumentPlanning - Represents the document planning module.
 */
export enum IndividualPlanningModuleEnum {
  KpiPlanning = "planning-kpi-definition",
  InitiativePlanning = "planning-initiative",
  RecurringActivityPlanning = "planning-recurring-activity",
  DocumentPlanning = "planning-documents",
  ObjectivePlanning = "planning-objective-definition"}

/**
 * Enum representing the field names for a selected user.
 * Each field corresponds to a specific attribute of a user profile.
 */
export enum SelectedUserFieldNameEnum {
  ID = "id",
  FIRSTNAME = "first_name",
  LASTNAME = "last_name",
  PROFILEIMAGE = "profile_image",
  PROFILECOLORHASH = "profile_color_hash"}

/**
 * Calculates the next quarter and its corresponding year based on the current date.
 * @returns An object containing the year and quarter number of the next quarter.
 * Example Output: { year: 2026, quarter: 1 }
 */
export const getNextQuarterYear = (): { year: number; quarter: number } => {
  const now = new Date();
  const currentMonth = now.getMonth(); // 0-based (January = 0)

  // Determine the current quarter
  const currentQuarter = Math.floor(currentMonth / 3) + 1;

  // Calculate next quarter
  const nextQuarter = currentQuarter === 4 ? 1 : currentQuarter + 1;
  const nextQuarterYear = currentQuarter === 4 ? currentYear + 1 : currentYear;

  return { year: nextQuarterYear, quarter: nextQuarter };
};

// Function to get years from start year to the next quarter year
export const getYearsToNextQuarterYear = (date: string): BaseOptionType[] => {
  const startYear = new Date(date).getFullYear();
  const nextQuarterYear = getNextQuarterYear().year; // Next year's quarter
  const yearArray: BaseOptionType[] = [];

  for (let y = startYear; y <= nextQuarterYear; y++) {
    yearArray.push({ label: y.toString(), value: y });
  }

  return yearArray.reverse();
};

/**
 * Generates a list of year options between the given start and end year (inclusive).
 *
 * The returned array is formatted as an array of BaseOptionType objects
 * where both `value` and `label` are string representations of the year.
 * The list is returned in descending order (latest year first).
 *
 * @param startYear - The starting year (inclusive).
 * @param endYear - The ending year (inclusive).
 * @returns Array of BaseOptionType objects formatted for dropdown/select components.
 *
 * @example
 * getYearsBetween(2020, 2023)
 * // Returns:
 * // [
 * //   { value: "2023", label: "2023" },
 * //   { value: "2022", label: "2022" },
 * //   { value: "2021", label: "2021" },
 * //   { value: "2020", label: "2020" }
 * // ]
 */
export const getYearsBetween = (
  startYear: number,
  endYear: number
): BaseOptionType[] => {
  const yearArray: BaseOptionType[] = [];

  for (let y = startYear; y <= endYear; y++) {
    yearArray.push({
      value: y.toString(),
      label: y.toString()});
  }

  return yearArray.reverse();
};

/**
 * Wrapper function that returns year-based options for select components.
 *
 * This function internally calls `getYearsBetween` to generate
 * the formatted year options. It is separated for semantic clarity
 * and potential future extension (e.g., additional formatting logic).
 *
 * @param startYear - The starting year (inclusive).
 * @param endYear - The ending year (inclusive).
 * @returns Array of BaseOptionType objects representing year options.
 */
export const getYearBaseOptions = (
  startYear: number,
  endYear: number
): BaseOptionType[] => {
  return getYearsBetween(startYear, endYear);
};
